_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
BoardSidebarPowerUpSlotView = require 'app/scripts/views/board-menu/board-sidebar-power-up-slot-view'
BusinessClassUpsellView = require 'app/scripts/views/directory/business-class-upsell-view'
{ dontUpsell } = require '@trello/config'
MemberState = require 'app/scripts/view-models/member-state'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
PopOver = require 'app/scripts/views/lib/pop-over'
Promise = require 'bluebird'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_power_up_slot')
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ Noun, Verb, trackUe } = require '@trello/analytics'

emptySlot = t.renderable ->
  t.li '.board-menu-navigation-item.mod-power-up-slot', ->
    t.a '.board-menu-navigation-item-link.js-power-up-empty-slot', { href: '#' }, ->
      t.span '.board-menu-navigation-item-link-icon'
      t.raw '&nbsp;'
      t.format 'add-power-up'

upsellSlot = t.renderable ->
  t.li '.board-menu-navigation-item.mod-power-up-slot', ->
    t.a '.board-menu-navigation-item-link.js-power-up-slot-upsell', { href: '#' }, ->
      t.span '.board-menu-navigation-item-link-icon'
      t.raw '&nbsp;'
      t.format 'unlock-more-power-ups'

template = t.renderable ->
  t.ul '.board-menu-navigation.js-power-up-slots'
  t.ul '.board-menu-navigation.js-upsell-slots'
  t.ul '.board-menu-navigation', ->
    t.li '.board-menu-navigation-item.mod-power-up-slot.js-show-fewer.hide', ->
      t.a '.board-menu-navigation-item-link', { href: '#' }, ->
        t.raw '&nbsp;'
        t.format 'show-fewer-power-ups'
    t.li '.board-menu-navigation-item.mod-power-up-slot.js-show-more.hide', ->
      t.a '.board-menu-navigation-item-link', { href: '#' }, ->
        t.raw '&nbsp;'
        t.format 'view-all-power-ups'

module.exports = class BoardSidebarPowerUpSlotsView extends View

  events:
    'click .js-show-fewer': 'showFewer'
    'click .js-show-more': 'showMore'
    'click .js-power-up-slot-upsell': 'toggleBusinessClassUpsell'

  initialize: ->
    @collapsed = false

    @makeDebouncedMethods 'renderPowerUpSlots'

    @listenTo @model,
      'change:idOrganization': @renderPowerUpSlotsDebounced

    @listenTo @model.boardPluginList,
      'add remove reset': (e) =>
        @renderPowerUpSlotsDebounced()

    @subscribe pluginsChangedSignal(@model), =>
      @renderPowerUpSlotsDebounced()

    @listenTo MemberState,
      'change:idBoardCollapsedPowerUps': @renderPowerUpSlotsDebounced

  toggleBusinessClassUpsell: (e) ->
    Util.stop(e)
    PopOver.toggle
      autoPosition: true
      hideHeader: true
      elem: e.target
      view: new BusinessClassUpsellView({ @model })
      displayType: 'directory-business-class-popover'

    if PopOver.isVisible
      trackUe(Noun.BOARD_VIEW, Verb.OPENS, 'Power-Up BC upgrade popover ad', '', '', 'by clicking the unlock more Power-Ups button')

  showFewer: (e) ->
    Util.stop(e)
    trackUe(Noun.BOARD_VIEW, Verb.HIDES, 'Power-Up sidebar slots', '', '', 'by clicking the show fewer Power-ups button')
    MemberState.pushBoardCollapsedPowerUps(@model.id)

  showMore: (e) ->
    Util.stop(e)
    trackUe(Noun.BOARD_VIEW, Verb.SHOWS, 'Power-Up sidebar slots', '', '', 'by clicking the view all Power-ups button')
    MemberState.pullBoardCollapsedPowerUps(@model.id)

  isCollapsed: ->
    MemberState.inSet('idBoardCollapsedPowerUps', @model.id)

  renderPowerUpSlots: ->
    collapsed = @isCollapsed()

    Promise.map @model.boardPluginList.models, (boardPlugin) =>
      PluginRunner.getOrLoadPlugin(@model, boardPlugin.get('idPlugin'))
    .map (plugin) =>
      @subview(BoardSidebarPowerUpSlotView, @model, {
        plugin
        currentPage: 'board view'
      }, plugin.id)
    .then (subviews) =>
      subviewsToRender = subviews

      if collapsed & subviews.length > 3
        subviewsToRender = _.first(subviews, 3)

      @ensureSubviews(subviewsToRender, @$('.js-power-up-slots'))
    .finally =>
      $powerUpSlotUpsellContainer = @$('.js-upsell-slots')
      $powerUpSlotUpsellContainer.empty()

      powerUpsCount = @model.powerUpsCount()

      isShowFewerVisible = powerUpsCount > 3 && !collapsed
      @$('.js-show-fewer').toggleClass('hide', !isShowFewerVisible)

      isShowMoreVisible = powerUpsCount > 3 && collapsed
      @$('.js-show-more').toggleClass('hide', !isShowMoreVisible)

      if @model.canEnableAdditionalPowerUps()
        me = Auth.me()
        numberOfEmptySlots = 1

        if me.isFeatureEnabled('threePlugins')
          numberOfEmptySlots = 3 - powerUpsCount

        if me.hasBCPowerUps()
          if powerUpsCount < 3
            numberOfEmptySlots = 3 - powerUpsCount
          else
            numberOfEmptySlots = 1

        _.times numberOfEmptySlots, ->
          $powerUpSlotUpsellContainer.append(emptySlot())
      else if !dontUpsell
        $powerUpSlotUpsellContainer.append(upsellSlot())

  render: ->
    @$el.html template()
    @renderPowerUpSlots()
    @
